export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? "http://localhost:8080";

// Caso o valor recebido não for REACT_APP_BACKEND_URL, então (??) receberá o padrão: localhost.